<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
    <div class="d-flex flex-column flex-lg-row gap-4">
      <main class="flex-grow-1">
        <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-3 mt-2">
          <div class="entity-config-top-hero px-2 px-md-2 py-2">
            <div class="row g-2 align-items-start flex-nowrap">
              <div class="col">
                <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">{{ pageTitle }}</h1>
                <p class="entity-page-subtitle text-white mb-0">{{ pageDescription }}</p>
              </div>
            </div>
          </div>

          <div class="px-2 px-md-2 pb-2">
            <section class="row entity-config-top-metrics">
              <div class="col-12 mt-2">
                <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
                  <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-2 mb-4">
                    <div>
                      <p class="fw-bold text-x text-dark mb-1">Create New Question</p>
                    </div>
                  </div>

                  <div class="row g-4 align-items-start">
                    <div :class="questionForm.show_option_inputs ? 'col-12 col-lg-7' : 'col-12'">
                      <div class="row g-4 align-items-end">
                        <div class="col-12 col-lg-6">
                          <label class="text-xs form-label fw-semibold mb-2">Question Text <span class="text-danger fs-6">*</span></label>
                          <input
                            v-model="questionForm.question_text"
                            type="text"
                            class="form-control form-control-sm bg-light border-0 rounded-3 text-xs"
                            placeholder="Is the building occupied?"
                          />
                        </div>

                        <div class="col-12 col-lg-6">
                          <label class="text-xs form-label fw-semibold mb-1">Question Number <span class="text-danger fs-6">*</span></label>
                          <input
                            v-model="questionForm.question_number"
                            type="text"
                            class="form-control form-control-sm bg-light border-0 rounded-3 text-xs"
                            placeholder="eg. 1"
                          />
                        </div>

                        <div class="col-12 col-lg-6">
                          <label class="text-xs form-label fw-semibold mb-1">Select Question Type <span class="text-danger fs-6">*</span></label>
                          <select
                            v-model="questionForm.question_type_id"
                            class="form-select form-select-sm bg-light border-0 rounded-3 text-xs"
                            :disabled="questionTypesLoading"
                            @change="handle_question_type_change"
                          >
                            <option disabled value="">
                              {{ questionTypesLoading ? 'Loading Question Types...' : 'Question Type' }}
                            </option>
                            <option v-for="type in questionTypes" :key="type.id" :value="type.id">
                              {{ type.label }}
                            </option>
                          </select>
                        </div>

                        <div class="col-12 col-lg-6">
                          <label class="text-xs form-label fw-semibold mb-1">Is The Question Mandatory? <span class="text-danger fs-6">*</span></label>
                          <select v-model="questionForm.is_mandatory" class="form-select form-select-sm bg-light border-0 rounded-3 text-xs">
                            <option disabled value="">Select Option</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                        </div>

                        <div v-if="questionForm.show_option_inputs" class="col-12">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-xs form-label fw-semibold mb-0">Options</label>
                            <button
                              type="button"
                              class="btn btn-primary-dark btn-sm rounded-3 text-xxs px-3 py-2"
                              @click="add_option_input(questionForm)"
                            >
                              <i class="bi bi-plus-lg"></i>
                            </button>
                          </div>

                          <div
                            v-for="(option, option_index) in questionForm.option_inputs"
                            :key="option_index"
                            class="mb-3 position-relative"
                          >
                            <input
                              v-model="questionForm.option_inputs[option_index]"
                              type="text"
                              class="form-control form-control-sm bg-light border-0 rounded-3 text-xs"
                              :placeholder="'Option ' + (option_index + 1)"
                            />
                            <button
                              v-if="questionForm.option_inputs.length > 2"
                              type="button"
                              class="btn btn-link text-danger p-0 position-absolute end-0 top-50 translate-middle-y me-3"
                              @click="remove_option_input(questionForm, option_index)"
                            >
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="questionForm.show_option_inputs"
                      :class="[
                        'col-12 col-lg-5 d-flex',
                        questionForm.dependant_questions && questionForm.dependant_questions.length ? 'align-items-start' : 'align-items-center'
                      ]"
                    >
                      <dependent-questions-panel
                        v-model="questionForm.dependant_questions"
                        :trigger-options="question_form_trigger_conditions"
                        :question-types="questionTypes"
                        :question-types-loading="questionTypesLoading"
                        :disabled="create_question_running"
                      />
                    </div>
                  </div>

                  <div class="d-flex justify-content-end mt-4">
                    <button
                      type="button"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                      @click="create_question"
                    >
                      Save Question
                    </button>
                  </div>
                </article>
              </div>
            </section>
          </div>
        </section>

        <section class="entity-inventory-panel rounded-4 border shadow-sm p-2 mb-4">
          <div class="row g-2 align-items-start align-items-lg-center mb-3">
            <div class="col-12 col-lg">
              <div class="d-flex align-items-center gap-3">
                <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
                  <i class="bi bi-ui-checks-grid"></i>
                </div>
                <div>
                  <div class="entity-section-title fw-bold fs-6">Manage Questions</div>
                  <p class="text-x text-secondary mb-0">Audit, edit, and reorganize existing form questions.</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-auto">
              <div class="d-grid d-sm-flex align-items-stretch gap-2">
                <div class="dropdown">
                  <button
                    class="btn manage-filter-btn dropdown-toggle d-inline-flex align-items-center justify-content-between text-xs"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>{{ selectedType === 'all' ? 'All Types' : selectedType }}</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-4 p-2">
                    <li>
                      <button class="dropdown-item rounded-3" type="button" @click="set_type_filter('All Types')">
                        All Types
                      </button>
                    </li>
                    <li v-for="type in questionTypes" :key="type.id">
                      <button class="dropdown-item rounded-3" type="button" @click="set_type_filter(type.label)">
                        {{ type.label }}
                      </button>
                    </li>
                  </ul>
                </div>

                <div class="position-relative flex-shrink-0 w-50 me-3">
                  <input
                    v-model="searchQuery"
                    type="text"
                    class="form-control form-control-sm text-xs rounded-small"
                    placeholder="Search current list..."
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
            <div class="row g-2 align-items-center">
              <div class="col-lg-1">No.</div>
              <div class="col-lg-4">Question</div>
              <div class="col-lg-2">Question Type</div>
              <div class="col-lg-3">Options</div>
              <div class="col-lg-2"></div>
            </div>
          </div>

          <div v-if="paginatedQuestions.length" class="d-flex flex-column gap-2">
            <article
              v-for="question in paginatedQuestions"
              :key="question.id"
              class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
            >
              <div class="entity-row-layout row g-2 align-items-center">
                <div class="col-12 col-lg-1 fw-bold text-xs">
                  {{ question.number }}
                </div>

                <div class="entity-name-block col-12 col-lg-4 d-flex align-items-start gap-3">
                  <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                    <i class="bi bi-question-circle-fill"></i>
                  </div>
                  <div>
                    <div class="entity-name fw-bold">{{ question.question }}</div>
                    <div class="d-flex align-items-center gap-2 text-secondary small">
                      <span class="manage-status-dot" :class="question.statusTone"></span>
                      <span>{{ question.subtitle }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-4 col-lg-2">
                  <span class="manage-type-pill text-xxs">{{ question.type }}</span>
                </div>

                <div class="col-12 col-sm-8 col-lg-3 text-secondary small fst-italic">
                  {{ question.options }}
                </div>

                <div class="col-12 col-lg-2 d-flex justify-content-end align-items-center gap-2 pt-2 pt-lg-0">
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_question_modal"
                    @click="open_edit_question_modal(question)"
                  >
                    Edit
                  </button>
                </div>
              </div>
            </article>
          </div>

          <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
            <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
              <i class="bi bi-ui-checks-grid fs-3"></i>
            </div>
            <div class="fw-bold mb-1">No Questions Found</div>
            <div class="text-secondary small">Questions will appear here once they are created.</div>
          </div>

          <div v-if="!questions_loading && paginatedQuestions.length" class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 px-2 py-3">
            <p class="mb-0 text-secondary text-xs">
              {{ paginationSummary }}
            </p>
            <nav>
              <ul class="pagination pagination-sm mb-0 manage-pagination text-xxs">
                <li class="page-item">
                  <button class="page-link" type="button" @click="set_page(pagination.current - 1)">
                    <i class="bi bi-chevron-left"></i>
                  </button>
                </li>
                <li
                  v-for="page in paginationPages"
                  :key="page"
                  class="page-item"
                  :class="{ active: pagination.current === page }"
                >
                  <button class="page-link" type="button" @click="set_page(page)">
                    {{ page }}
                  </button>
                </li>
                <li class="page-item">
                  <button class="page-link" type="button" @click="set_page(pagination.current + 1)">
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </section>
      </main>
    </div>

    <teleport to="body">
      <div  id="edit_question_modal" class="modal fade" tabindex="-1" aria-labelledby="edit_question_label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs">Edit Question</p>
              <button
                type="button"
                class="modal-btn-close btn-close"
                aria-label="Close"
                data-bs-dismiss="modal"
                @click="close_edit_question_modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="modal-form-group form-group mb-3">
                <label class="modal-form-label form-label text-xxs"><span class="text-danger fs-6">*</span>Question:</label>
                <input
                  type="text"
                  v-model="current_edit_question.question_text"
                  class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
                  placeholder="Question here"
                />
                <label class="modal-form-label form-label text-xxs">Question Description:</label>
                <input
                  type="text"
                  v-model="current_edit_question.question_description"
                  class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
                  placeholder="Question Description here"
                />
                <label class="modal-form-label form-label text-xxs"><span class="text-danger fs-6">*</span>Question Number:</label>
                <input
                  type="text"
                  v-model="current_edit_question.question_number"
                  class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
                  placeholder="Question here"
                />
                <label class="modal-form-label form-label text-xxs"><span class="text-danger fs-6">*</span>Question Type:</label>
                <select
                  v-model="current_edit_question.question_type_id"
                  class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm mb-3"
                  :disabled="questionTypesLoading"
                  @change="handle_question_type_change_for_edit(current_edit_question)"
                >
                  <option value="" disabled>Select Type</option>
                  <option v-for="type in questionTypes" :key="type.id" :value="type.id">
                    {{ type.label }}
                  </option>
                </select>
                <label class="modal-form-label form-label text-xxs"><span class="text-danger fs-6">*</span>Mandatory:</label>
                <select
                  v-model="current_edit_question.is_mandatory"
                  class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm mb-3"
                >
                  <option value="">Select Option</option>
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
              </div>

              <div v-if="current_edit_question.show_option_inputs" class="mt-3">
                <div class="row mb-2">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <label class="form-label text-xs mb-0">Options</label>
                    <button type="button" @click="add_option_input(current_edit_question)" class="btn-primary-dark btn-sm rounded-3 fw-bold text-xs shadow me-2">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>

                <div v-for="(option, option_index) in current_edit_question.option_inputs" :key="option_index" class="mb-3 position-relative">
                  <input
                    v-model="current_edit_question.option_inputs[option_index]"
                    type="text"
                    class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm"
                    :placeholder="'Option ' + (option_index + 1)"
                  />
                  <button
                    v-if="current_edit_question.option_inputs && current_edit_question.option_inputs.length > 2"
                    type="button"
                    class="btn btn-link text-danger p-0 position-absolute end-0 top-50 translate-middle-y me-3"
                    @click="remove_option_input(current_edit_question, option_index)"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>

              <div class="mt-4 border-top pt-3">
                <div
                  v-for="(dep_question, dep_index) in current_edit_question.dependant_questions"
                  :key="dep_question.id || dep_index"
                  class="mb-4 p-3 border rounded"
                >
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0 text-xs fw-bold">
                      Dependent Question {{ dep_index + 1 }}
                    </h6>
                    <button
                      type="button"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                      @click="remove_dependent_question(current_edit_question, dep_index)"
                    >
                      Remove
                    </button>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="form-label text-xs">Question Text<span class="text-danger fs-6">*</span></label>
                      <input
                        v-model="dep_question.question_text"
                        type="text"
                        class="form-control text-xxs rounded-small shadow-sm"
                        placeholder="e.g. What is your first name?"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label text-xs">Trigger Condition<span class="text-danger fs-6">*</span></label>
                      <select
                        v-if="current_edit_question.show_option_inputs && current_edit_question.option_inputs && current_edit_question.option_inputs.length > 0"
                        v-model="dep_question.trigger_condition"
                        class="form-control text-xxs rounded-small shadow-sm"
                      >
                        <option value="" disabled>Select a trigger condition</option>
                        <option v-for="(option, opt_index) in current_edit_question.option_inputs" :key="opt_index" :value="option">
                          {{ option }}
                        </option>
                      </select>
                      <input
                        v-else
                        v-model="dep_question.trigger_condition"
                        type="text"
                        class="form-control text-xxs rounded-small shadow-sm"
                        placeholder="Trigger value"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label text-xs">Mandatory</label>
                      <select v-model="dep_question.is_mandatory" class="form-select text-xxs rounded-small shadow-sm">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-label text-xs">Question Type<span class="text-danger fs-6">*</span></label>
                      <select
                        v-model="dep_question.question_type_id"
                        class="form-select text-xxs rounded-small shadow-sm"
                        @change="handle_dependent_question_type_change(dep_question)"
                      >
                        <option value="" disabled hidden>Select Type</option>
                        <option v-for="type in questionTypes" :key="type.id" :value="type.id">
                          {{ type.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label text-xs">Question Number</label>
                      <input
                        v-model="dep_question.question_number"
                        type="text"
                        class="form-control text-xxs rounded-small shadow-sm"
                        placeholder="e.g. 1.1"
                      />
                    </div>
                  </div>

                  <div v-if="dep_question.show_option_inputs" class="mt-3">
                    <div class="row mb-2">
                      <div class="col-12 d-flex justify-content-between align-items-center">
                        <label class="form-label text-xs mb-0">Options</label>
                        <div>
                          <button type="button" @click="add_dependent_option(dep_question)" class="btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white me-2">
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div v-for="(option, option_index) in dep_question.options" :key="option_index" class="row mb-3">
                      <div class="col-10">
                        <input
                          v-model="dep_question.options[option_index].choice"
                          type="text"
                          class="form-control text-xs rounded-small p-2 shadow-sm"
                          placeholder="Option value"
                        />
                      </div>
                      <div class="col-2">
                        <button type="button" @click="remove_dependent_option(dep_question, option_index)" class="btn btn-outline-danger btn-sm rounded-circle">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h6 class="mb-0 text-xs">Dependent Questions</h6>
                  <button
                    type="button"
                   class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                    @click="add_dependent_question(current_edit_question)"
                  >
                    Add Dependent Question
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button
                type="button"
                 class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="save_edited_question"
                :disabled="edit_question_running"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </teleport>
</div>
